const isProduction = process.env.REACT_APP_IS_PRODUCTION === 'true';
type LogArgs = Parameters<typeof console.log>;
/**
 * コンソールにログを出力する。
 * 本番環境では出力しない。
 */
const log = (...args: LogArgs) => {
  if (!isProduction) {
    console.log(...args);
  }
};
type InfoArgs = Parameters<typeof console.info>;
/**
 * コンソールに info レベルのログを出力する。
 * 本番環境では出力しない。
 */
const info = (...args: InfoArgs) => {
  if (!isProduction) {
    console.info(...args);
  }
};
type DebugArgs = Parameters<typeof console.debug>;
/**
 * コンソールに debug レベルのログを出力する。
 * 本番環境では出力しない。
 */
const debug = (...args: DebugArgs) => {
  if (!isProduction) {
    console.debug(...args);
  }
};
type WarnArgs = Parameters<typeof console.warn>;
/**
 * コンソールに warn レベルのログを出力する。
 * 本番環境では出力しない。
 */
const warn = (...args: WarnArgs) => {
  if (!isProduction) {
    console.warn(...args);
  }
};
type ErrorArgs = Parameters<typeof console.error>;
/**
 * コンソールに error レベルのログを出力する。
 * 本番環境では出力しない。
 */
const error = (...args: ErrorArgs) => {
  if (!isProduction) {
    console.error(...args);
  }
};

export const logger = {
  log,
  info,
  debug,
  warn,
  error,
};
